import { useTemplateContext } from "shared/app/VerificationTemplate/provider";
import { CheckboxCard } from "shared/components/forms/CheckboxCard";
import { Radio } from "shared/components/forms/Radio";
import { RecommendationMethod } from "types/landlord/verificationTemplate";

export const DecisionCriteriaRadio = ({
  decisionRecommendation,
  setDecision,
  value,
  title,
  subTitle
}: {
  decisionRecommendation: RecommendationMethod;
  value: RecommendationMethod;
  setDecision?: (v: RecommendationMethod) => void;
  title: string;
  subTitle: string;
}) => {
  const id = "criteriaEnabled-" + value;
  const { readOnly } = useTemplateContext();
  return (
    <CheckboxCard
      id={id}
      name="criteriaEnabled"
      wrapperClassName="max-w-[271px] h-full"
      className="h-full"
      label={
        <>
          <Radio
            name="criteriaEnabled"
            id={id + "-mock"}
            checked={decisionRecommendation === value}
            onChange={() => null}
            className="mb-6"
          />
          <h3 className="text-sm font-bold text-content-700 mb-2">{title}</h3>
          <p className="text-sm text-content-400">{subTitle}</p>
        </>
      }
      checked={decisionRecommendation === value}
      onChange={() => {
        if (readOnly) return;
        setDecision?.(value);
      }}
    />
  );
};
